import React from "react";
import { useNavigate } from "react-router-dom";
import MultilingualProductForm from "./MultilingualProductForm";
import { useCreateProductMutation } from "../../redux/api/productsApi";
import { useGetManufacturersQuery } from "../../redux/api/manufacturersApi";
import { toast } from "react-toastify";

const AddProductPage = () => {
  const navigate = useNavigate();
  
  const { data: manufacturers = [], isLoading: manufacturersLoading } = useGetManufacturersQuery();
  const [createProduct, { isLoading: isCreating, error: createError }] = useCreateProductMutation();

  const loading = manufacturersLoading || isCreating;
  const error = createError;

  const handleAddProduct = async (data) => {
    try {
      const result = await createProduct(data).unwrap();
      toast.success("Product created successfully!");
      navigate("/products");
      return result;
    } catch (err) {
      toast.error(err?.data?.message || err?.error || "Failed to create product");
      throw err;
    }
  };

  return (
    <div>
      <h1 className="mb-4">Add Product</h1>
      {loading && <p>Loading...</p>}
      {error && <p className="text-danger">Error: {error?.data?.message || error?.error || 'Unknown error'}</p>}
      <MultilingualProductForm manufacturers={manufacturers} onSubmit={handleAddProduct} />
    </div>
  );
};

export default AddProductPage;
